export const digitalClientMapper: { [key: string]: string } = {
  ECOMMERCE: 'C',
  SOL: 'L'
};

export const salesOrgMapper: { [key: string]: string } = {
  IT: 'O50000001'
};
